module.exports = __webpack_public_path__ + "static/img/areaB_10(1).0ce34c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_10(1).png
// module id = 1272
// module chunks = 1